const SET_SALES_YEAR = 'app/financialYearSelector/SET_SALES_YEAR';

const setSalesYear = (salesYear) => ({
  type: SET_SALES_YEAR,
  salesYear: salesYear,
});

export { SET_SALES_YEAR, setSalesYear };
